import {
  isZhwxDk87DisplayCell,
  isZhwxDk87MatrixUsable,
  isZhwxDk87PhysicalCell,
  ZHWX_DK87_FACTORY_MATRIX_BYTES,
  ZHWX_DK87_FN_FACTORY_MATRIX_BYTES,
  ZHWX_DK87_NON_PHYSICAL_CELLS,
  TOTAL_DK87_KEY_WIDTHS,
  type ZhwxMatrixCell,
} from "./zhwxDk87Layout";
import {
  isZhwxDk75SingleDisplayCell,
  isZhwxDk75SingleMatrixUsable,
  isZhwxDk75SinglePhysicalCell,
  normalizeZhwxDk75SingleRemapCol,
  TOTAL_DK75_SINGLE_KEY_WIDTHS,
  ZHWX_DK75_SINGLE_FACTORY_MATRIX_BYTES,
  ZHWX_DK75_SINGLE_FN_FACTORY_MATRIX_BYTES,
  ZHWX_DK75_SINGLE_NON_PHYSICAL_CELLS,
} from "./zhwxDk75SingleLayout";
import { isZhwxKeyboardType, type ZhwxKeyboardType } from "./zhwxKeyboardTypes";

export type ZhwxLayoutProfile = {
  keyboardType: ZhwxKeyboardType;
  factoryMatrixBytes: Uint8Array;
  fnFactoryMatrixBytes: Uint8Array;
  nonPhysicalCells: ReadonlyArray<readonly [number, number]>;
  keyWidths: number[][];
  isPhysicalCell: (row: number, col: number) => boolean;
  isDisplayCell: (row: number, col: number, cell: ZhwxMatrixCell) => boolean;
  isMatrixUsable: (matrix: Uint8Array) => boolean;
  normalizeRemapCol: (row: number, col: number) => number;
};

const ZHWX_DK87_PROFILE: ZhwxLayoutProfile = {
  keyboardType: "dk87",
  factoryMatrixBytes: ZHWX_DK87_FACTORY_MATRIX_BYTES,
  fnFactoryMatrixBytes: ZHWX_DK87_FN_FACTORY_MATRIX_BYTES,
  nonPhysicalCells: ZHWX_DK87_NON_PHYSICAL_CELLS,
  keyWidths: TOTAL_DK87_KEY_WIDTHS,
  isPhysicalCell: isZhwxDk87PhysicalCell,
  isDisplayCell: isZhwxDk87DisplayCell,
  isMatrixUsable: isZhwxDk87MatrixUsable,
  normalizeRemapCol(row, col) {
    if (row === 5 && col >= 6 && col <= 9) return 5;
    return col;
  },
};

const ZHWX_DK75_SINGLE_PROFILE: ZhwxLayoutProfile = {
  keyboardType: "dk75Single",
  factoryMatrixBytes: ZHWX_DK75_SINGLE_FACTORY_MATRIX_BYTES,
  fnFactoryMatrixBytes: ZHWX_DK75_SINGLE_FN_FACTORY_MATRIX_BYTES,
  nonPhysicalCells: ZHWX_DK75_SINGLE_NON_PHYSICAL_CELLS,
  keyWidths: TOTAL_DK75_SINGLE_KEY_WIDTHS,
  isPhysicalCell: isZhwxDk75SinglePhysicalCell,
  isDisplayCell: isZhwxDk75SingleDisplayCell,
  isMatrixUsable: isZhwxDk75SingleMatrixUsable,
  normalizeRemapCol: normalizeZhwxDk75SingleRemapCol,
};

/** 按 keyboardType 解析智慧无限布局配置，未知型号回退 DK87 */
export function resolveZhwxLayoutProfile(
  keyboardType?: string | null
): ZhwxLayoutProfile {
  if (keyboardType === "dk75Single") return ZHWX_DK75_SINGLE_PROFILE;
  return ZHWX_DK87_PROFILE;
}

/** 规范化 keyboardType，默认 dk87 */
export function normalizeZhwxKeyboardType(
  keyboardType?: string | null
): ZhwxKeyboardType {
  return isZhwxKeyboardType(keyboardType) ? keyboardType : "dk87";
}
